import React from "react";
import {
    IconButton,
    TableCell,
} from "@mui/material";
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DownloadIcon from '@mui/icons-material/DownloadOutlined';

export default function TableRowButton(props) {
    return (
        <>
            <TableCell
                sx={{
                    maxWidth: { xs: '10vw', sm: '20%', md: '15%' },
                    padding: { xs: '5px', ms: '8px', sm: '16px' },
                    borderBottom: 'none'
                }}
            >
                <IconButton color="default" onClick={() => props.setOpen(!props.open)}>
                    <ModeEditOutlinedIcon />
                </IconButton>
            </TableCell>
            {/* ダウンロードは一時的に停止 */}
            {/* {props.hasDownload &&
                <TableCell
                    sx={{
                        maxWidth: { xs: '10vw', sm: '20%', md: '15%' },
                        padding: { xs: '5px', ms: '8px', sm: '16px' },
                        borderBottom: 'none'
                    }}
                >
                    <IconButton color="default" disabled={!props.is_copyright}
                        onClick={() => {
                            props.setSingleDownloadDialogOpen(true)
                            props.setDownloadMessage1(`「${props.title}」をダウンロードします。よろしいですか？`)
                            props.setTargetId(props.id)
                            props.setTargetTitle(props.title)
                                }}
                    >
                        <DownloadIcon />
                    </IconButton>
                </TableCell>
            } */}
            <TableCell
                sx={{
                    maxWidth: { xs: '10vw', sm: '20%', md: '15%' },
                    padding: { xs: '5px', sm: '8px', md: '16px' },
                    borderBottom: 'none'
                }}>
                <IconButton color="default" onClick={() => {
                    props.setOpen(false)
                    props.setDeleteConfirmOpen(true)
                    props.setTargetId(props.id)
                    props.setTargetTitle(props.title)
                }}>
                    <DeleteOutlineOutlinedIcon />
                </IconButton>
            </TableCell>
        </>
    )
}